export const uriPattern = /^https?:\/\/.+$/;
